
import { defineComponent } from "vue";

export default defineComponent({
  name: "filterEdit",
  props: {
    waitingForSave: {
      type: Boolean,
      requiered: false
    }
  },
  computed: {
    waitingForSaveItem(): boolean {
      return this.waitingForSave;
    }
  }
});
